var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloudIdeaSolid = function SvgCloudIdeaSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.023 17.797a.785.785 0 0 1-.07.003 5.49 5.49 0 0 1-3.813-1.529 5.174 5.174 0 0 1-1.593-3.721c0-1.4.576-2.739 1.593-3.721a5.474 5.474 0 0 1 3.237-1.5C6.812 6.04 7.721 4.937 8.94 4.202a6.624 6.624 0 0 1 2.26-.845 6.85 6.85 0 0 1 2.434.006c.804.148 1.57.438 2.256.858.686.419 1.279.96 1.742 1.595.464.635.788 1.35.951 2.107.098.454.136.917.115 1.378h.135c1.12 0 2.193.45 2.983 1.247a4.268 4.268 0 0 1 1.232 3.003 4.268 4.268 0 0 1-1.232 3.002 4.196 4.196 0 0 1-2.983 1.248h-.941a.785.785 0 0 1-.07-.003h-1.176a5 5 0 1 0-8.29 0H7.023Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.751 15c0 1.228.59 2.317 1.5 3v1.286c0 .966.784 1.75 1.75 1.75h1a1.75 1.75 0 0 0 1.75-1.75V18a3.75 3.75 0 1 0-6-3Zm1.5 0a2.25 2.25 0 1 1 3.534 1.849h-2.567A2.247 2.247 0 0 1 10.252 15Zm1.5 4.286v-.937h1.5v.937a.25.25 0 0 1-.25.25h-1a.25.25 0 0 1-.25-.25Z",
    fill: "currentColor"
  })));
};
export default SvgCloudIdeaSolid;